<template>
  <div>
    <canvas width="800" height="250"></canvas>

    <ChannelTypeBreakdownModal :period="period" :portal="portal" :dataset="dataset"/>
  </div>
</template>

<script>
import datalabels from 'chartjs-plugin-datalabels'
import Chart from 'chart.js'
import ChannelTypeBreakdownModal from '@/components/Modals/Dashboard/Advertising/ChannelTypeBreakdownModal'

const totalizer = {
  id: 'totalizer',

  beforeUpdate: chart => {
    let totals = {}
    let utmost = 0

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        utmost = datasetIndex

        dataset.data.forEach((value, index) => {
          totals[index] = (totals[index] || 0) + (datasetIndex > 0 ? value : 0)
        })
      }
    })

    chart.$totalizer = {
      totals: totals,
      utmost: utmost
    }
  }
}

export default {
  components: {ChannelTypeBreakdownModal},

  props: {
    targetMetric: {},
    portal: {},
    granularity: {},
    data: {},
    dataset: {}
  },

  mounted() {
    this.$nextTick(this.draw)
  },

  watch: {
    targetMetric() {
      this.$nextTick(this.draw)
    },

    data() {
      this.$nextTick(this.draw)
    },

    dataset() {
      this.$nextTick(this.draw)
    }
  },

  data() {
    return {
      chart: null,
      period: null,
    }
  },

  computed: {
    internalTargetMetric() {
      return this.targetMetric === 'ad_target' ? 'target' : 'management_target'
    },

    targetValues() {
      if (this.dataset) {
        return this.data.datasets.find(dataset => dataset.id === this.dataset)[this.internalTargetMetric]
      }

      return this.data.periods.map((period, index) => this.data.datasets.reduce((result, dataset) => result + dataset[this.internalTargetMetric][index], 0))
    }
  },

  methods: {
    draw() {
      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
        plugins: [datalabels, totalizer],

        type: 'bar',

        data: {
          labels: this.data.periods,
          datasets: [
            {
              label: 'Target',
              data: this.targetValues,
              type: 'line',
              backgroundColor: '#888888',
              borderColor: '#888888',
              fill: false
            },
            ...this.data.datasets.filter(dataset => this.dataset ? dataset.id === this.dataset : true).map(dataset => ({
              label: dataset.name,
              data: dataset.values,
              backgroundColor: dataset.color,
            }))
          ]
        },

        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: value => this.$options.filters.price(value)
              }
            }]
          },

          legend: {
            position: 'bottom'
          },

          layout: {
            padding: {
              top: 25
            }
          },

          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              formatter: (value, ctx) => this.$options.filters.price(ctx.chart.$totalizer.totals[ctx.dataIndex]),
              display: (ctx) => ctx.datasetIndex === ctx.chart.$totalizer.utmost
            }
          },

          tooltips: {
            callbacks: {
              label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
            }
          },

          onClick: (event, elements) => {
            if (elements.length) {
              this.period = this.data.periods[elements[0]['_index']]

              this.$nextTick(() => $('#channel-type-breakdown-modal').modal('show'))
            }
          }
        }
      });
    },
  }
}
</script>
